<template>
    <v-img class="ma-1" width="20" height="20" src="@/assets/images/flags/vi.png"></v-img>
</template>

<script>
    export default {
        name: "FlagVi"
    }
</script>
